import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full rounded-none border border-white/[0.1] bg-black/40 p-4 text-sm text-white outline-none transition-all duration-300 placeholder:text-gray-600 focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF]";

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error("Completa todos los campos.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      toast.success("¡Mensaje enviado! Te contactaremos pronto.");
      setForm({ name: "", email: "", message: "" });
      setTimeout(() => setSent(false), 4000);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(
        typeof detail === "string"
          ? detail
          : "No se pudo enviar. Intenta de nuevo."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.form
      data-testid="contact-form"
      onSubmit={onSubmit}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="relative border border-white/[0.08] bg-white/[0.015] p-6 backdrop-blur-xl sm:p-8"
    >
      <span className="absolute left-0 top-0 h-3 w-3 border-l border-t border-[#00F0FF]/40" />
      <span className="absolute bottom-0 right-0 h-3 w-3 border-b border-r border-[#00F0FF]/40" />

      <p className="mb-1 font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF]/70">
        Contacto
      </p>
      <h3 className="mb-6 text-xl font-light text-white sm:text-2xl">
        Cuéntanos tu proyecto
      </h3>

      <div className="space-y-4">
        <input
          data-testid="contact-name"
          className={inputCls}
          placeholder="Nombre"
          value={form.name}
          onChange={update("name")}
          maxLength={120}
        />
        <input
          data-testid="contact-email"
          type="email"
          className={inputCls}
          placeholder="Correo electrónico"
          value={form.email}
          onChange={update("email")}
        />
        <textarea
          data-testid="contact-message"
          className={`${inputCls} min-h-[120px] resize-none`}
          placeholder="Tu mensaje"
          value={form.message}
          onChange={update("message")}
          maxLength={4000}
        />
      </div>

      <button
        data-testid="contact-submit"
        type="submit"
        disabled={loading}
        className="group mt-6 flex w-full items-center justify-center gap-2 rounded-none bg-white px-8 py-4 text-sm font-medium tracking-wide text-black transition-all duration-300 hover:bg-[#00F0FF] hover:shadow-[0_0_24px_rgba(0,240,255,0.4)] disabled:opacity-60"
      >
        {loading ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" /> Enviando…
          </>
        ) : sent ? (
          <>
            <Check className="h-4 w-4" /> Enviado
          </>
        ) : (
          <>
            Enviar mensaje
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </>
        )}
      </button>
    </motion.form>
  );
};

export default ContactForm;
